import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { PlantAnalysisDTO } from './types';

interface UseGetPlantAnalysisByIdOptions<TData> {
	enabled?: boolean;
	select?: (data: PlantAnalysisDTO) => TData;
}

export const useGetPlantAnalysisById = <TData = PlantAnalysisDTO>(
	id?: string,
	options?: UseGetPlantAnalysisByIdOptions<TData>
) => {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['plantAnalysisId', id, forBinding],
		enabled: (options?.enabled ?? true) && !!id,
		queryFn: async () => {
			const { data } = await api.get<PlantAnalysisDTO>(`/plant-analysis/get/${id}`, {
				params: { forBinding },
			});
			return data;
		},
		select: options?.select,
	});
};
